export enum Networks {
  WIFI = "wifi",
  WIMAX = "wimax",
  // mobile
  MOBILE = "mobile",

  // Android L calls this Cellular, because I have no idea!
  CELLULAR = "cellular",
  // 2G network types
  TWO_G = "2g",
  GSM = "gsm",
  GPRS = "gprs",
  EDGE = "edge",
  // 3G network types
  THREE_G = "3g",
  CDMA = "cdma",
  UMTS = "umts",
  HSPA = "hspa",
  HSUPA = "hsupa",
  HSDPA = "hsdpa",
  ONEXRTT = "1xrtt",
  EHRPD = "ehrpd",
  // 4G network types
  FOUR_G = "4g",
  LTE = "lte",
  UMB = "umb",
  HSPA_PLUS = "hspa+",
}

export enum NetworksType {
  // return type
  TYPE_UNKNOWN = "unknown",
  TYPE_ETHERNET = "ethernet",
  TYPE_ETHERNET_SHORT = "eth",
  TYPE_WIFI = "wifi",
  TYPE_2G = "2g",
  TYPE_3G = "3g",
  TYPE_4G = "4g",
  TYPE_NONE = "none",
}

/**
 * Handle connection address type
 */
export enum ConnectionType {
  NONE = 0,
  LAN = 1,
  WAN = 2,
  LANWAN = 10, //it's used when both lan and wan address are the same
}

/**
 * Handle connection address type
 */
export enum RegisteredAppLanguage {
  ITA = "it",
  ENG = "en",
  FRA = "fr",
  ESP = "es",
  DEU = "de",
}
